import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

export const textRecipe = defineStyleConfig({
  baseStyle: defineStyle(() => ({
    color: 'primary.500',
    fontSize: { base: '14px', md: '16px' },
  })),
  defaultProps: {
    size: 'md',
  },
});

export default textRecipe;
